import React from 'react';
import Modal from '../../../components/Modal';
import { triggerOptions } from '../../../seeds/crm/automations';

// Passo 1 de "Nova automação": escolher o que dispara (cartões grandes).
export const TriggerPickerModal = ({ show, close, onPick, available }) => {
    const options = available
        ? triggerOptions.filter((o) => available.includes(o.value))
        : triggerOptions;

    return (
        <Modal title="O que deve disparar a automação?" show={show} close={close}>
            <div className="trigger-picker">
                {options.map((option) => (
                    <button
                        key={option.value}
                        type="button"
                        className="trigger-picker__card"
                        onClick={() => onPick(option.value)}
                    >
                        <span className="trigger-picker__icon">{option.icon}</span>
                        <span className="trigger-picker__text">
                            <strong>{option.title}</strong>
                            <small>{option.description}</small>
                        </span>
                    </button>
                ))}
            </div>
        </Modal>
    );
};

export default TriggerPickerModal;
